// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"101":"47718a41","845":"bc435214"}[chunkId] + ".chunk.css";
};